import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "customerDialog",
    "customerForm",
    "customerIdField",
    "storageUnitDialog",
    "storageUnitForm",
    "storageUnitIdField",
  ]

  chooseCustomer() {
    this.#closeDialog(this.customerDialogTarget)
  }

  chooseStorageUnit() {
    this.#closeDialog(this.storageUnitDialogTarget)
  }

  openCustomerDialog(event) {
    const dataset = event.currentTarget.dataset
    this.customerFormTarget.action = dataset.selectUrl
    if (dataset.selectedStorageUnitId) {
      this.storageUnitIdFieldTarget.value = dataset.selectedStorageUnitId
    } else {
      this.storageUnitIdFieldTarget.value = ""
    }
    this.#openDialog(this.customerDialogTarget)
    this.customerDialogTarget.querySelector("input[type='search']").focus()
  }

  openStorageUnitDialog(event) {
    const dataset = event.currentTarget.dataset
    this.storageUnitFormTarget.action = dataset.selectUrl
    if (dataset.selectedCustomerId) {
      this.customerIdFieldTarget.value = dataset.selectedCustomerId
    } else {
      this.customerIdFieldTarget.value = ""
    }
    this.#openDialog(this.storageUnitDialogTarget)
    this.storageUnitDialogTarget.querySelector("input[type='search']").focus()
  }

  #openDialog(target) {
    const dialogElement = target.querySelector('[data-controller*="dialog"]')
    const controller = this.application.getControllerForElementAndIdentifier(
      dialogElement,
      "dialog"
    )
    controller?.open()
  }

  #closeDialog(target) {
    const dialogElement = target.querySelector('[data-controller*="dialog"]')
    const controller = this.application.getControllerForElementAndIdentifier(
      dialogElement,
      "dialog"
    )
    controller?.closeDialog()
  }
}
